import { useCallback, useEffect, useRef, useState } from "react"
import { getAdminCommunityMastermind, getAdminCommunityOpen, getAdminCommunityPending, getAdminCommunityStats } from "../../services/membersAdminService";
import { CommunityPost } from "./models/CommunityPost";

interface APITableResult<T> {
    count: number;
    next: T | null;
    previous: T | null;
    results: T[];
}

export const useCommunityMemeberOpen = (userId: number, reloadKey?: number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState<CommunityPost[]>([]);
    const [openPage, setOpenPage] = useState(1);
    const [openTotalPages, setOpenTotalPages] = useState(0);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const totalPages = (count: number) => Math.ceil(count / 5);

    const load = useCallback(async () => {
        if(!userId)
            return;
        try {
            setLoading(true);
            const _open = await getAdminCommunityOpen(userId, openPage-1) as APITableResult<CommunityPost>
            if(!isMountedRef.current)
                return;

            if(!!_open) {
                setOpen(_open.results);
                setOpenTotalPages(totalPages(_open.count));
            }
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [userId, openPage, reloadKey]);

    useEffect(() => {
        load();
    }, [load]);

    return { 
        loading,
        open,
        openPage,
        openTotalPages,
        setOpenPage
    }
}